import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SystemSiteService } from 'app/services/system-site.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
  closeResult: string;
  submitState: 'pending' | 'success' | 'error' = 'pending';
  selected_department: String = "Sales";
  contactUsForm: UntypedFormGroup;
  sendEmailSubscription: Subscription;
  socialData: any = []
  branchData: any = []
  packageData: any = []
  socialSubscription: Subscription = null;
  branchSubscription: Subscription = null;
  parameterSubscription: Subscription = null;
  newsSubscription

  center: google.maps.LatLngLiteral = { lat: -26, lng: 28 };
  zoom = 14;
  markerOptions: google.maps.MarkerOptions = { draggable: false };
  markerPositions: any[] = [];


  constructor(private fb: UntypedFormBuilder, private recaptchaV3Service: ReCaptchaV3Service, private systemSiteService: SystemSiteService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute) {

    this.contactUsForm = this.fb.group(
      {
        website: [''],
        practice_number: [''],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        mobile: ['', Validators.required],
        subject: ['', Validators.required],
        message: ['', Validators.required],
        selected_department: ['sales', Validators.required],
        selected_region: ['', Validators.required],

      }
    )

  }

  get f() {
    return this.contactUsForm.controls;
  }

  ngOnInit() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('contact-page');
    this.LoadData();

    this.parameterSubscription = this.route.params.subscribe(params => {

      if (params.type) {

        if (params.type == 'package') {

          if (params.data && params.data != '') {

            let pre_email_text = 'Good Day eMD Sales,\n\nI am interested in your ' + params.data + ' package.\n\nPlease contact me.\n\nKind Regards'


            this.packageData = params.data;
            this.contactUsForm.patchValue({ "message": pre_email_text, "subject" :   "Request for " + params.data + " information" })
          }
        }
        if (params.type == 'request') {

          if (params.data && params.data != '') {

            let pre_email_text = 'Good Day eMD Sales,\n\nI am interested in scheduling a demonstration to explore your practice management software.\n\nPlease contact me.\n\nKind Regards'


            this.packageData = params.data;
            this.contactUsForm.patchValue({ "message": pre_email_text , "subject" :   "Request for Practice Management Software Demonstration" })
          }
        }

      }




    });




  }


  getPosition(lat: any, lng: any): any {
    return { lat: parseFloat(lat), lng: parseFloat(lng) }
  }





  LoadData() {
    this.socialSubscription = this.systemSiteService.get_social().subscribe({
      next: data => {
        console.log(data.result_data)
        this.socialData = data.result_data;
      },
      error: error => { console.log(error) },
    })


    this.branchSubscription = this.systemSiteService.get_branch().subscribe({
      next: data => {
        console.log(data.result_data)
        this.branchData = data.result_data;



      },
      error: error => { console.log(error) },
    })


  }


  ngOnDestroy() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('contact-page');




    if (this.socialSubscription)
      this.socialSubscription.unsubscribe();
    if (this.branchSubscription)
      this.branchSubscription.unsubscribe();
    if (this.sendEmailSubscription)
      this.sendEmailSubscription.unsubscribe();



  }

  
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async open(content, type) {
    if (type === 'sm') {
      console.log('aici');
      this.modalService.open(content, { size: 'sm' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {

      this.submitState = 'pending';

      this.modalService.open(content).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });

      let formValues = this.contactUsForm.getRawValue();

      this.sendEmailSubscription = this.recaptchaV3Service.execute('contact_form').pipe(
        switchMap((token) => {
          formValues.recaptcha_token = token;
          return this.systemSiteService.contact_form_email(formValues);
        })
      ).subscribe({
        next: async () => {
          this.submitState = 'success';
          await this.delay(1500);
          this.modalService.dismissAll();
          this.router.navigate(['']);
        },
        error: (error) => {
          console.log(error);
          this.submitState = 'error';
        },
      })
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }







}
